<div class="toast-stack">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [class.toast--warning]="toast.type === 'warning'">
      <div class="toast-accent"></div>
      <span class="toast-icon">
        <app-icon [name]="toast.type === 'warning' ? 'warning' : 'check'" [size]="16"></app-icon>
      </span>
      <div class="toast-body">
        @if (toast.type === 'info' || toast.type === 'warning') {
          <span class="toast-title">{{ toast.message }}</span>
        } @else {
          <span class="toast-title">Added to cart</span>
          <span class="toast-desc">
            {{ toast.productName }} &mdash;
            <a routerLink="/checkout" [queryParams]="{ from: 'product', code: toast.productCode }" class="toast-link" (click)="toastService.dismiss(toast.id)">View cart</a>
          </span>
        }
      </div>
      <button class="toast-close" (click)="toastService.dismiss(toast.id)" aria-label="Dismiss">
        <app-icon name="close" [size]="14"></app-icon>
      </button>
    </div>
  }
</div>
